import React, { useState } from "react";

import ajaxUser from "../util/remote/ajaxUser";

import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      email: email,
    };
    const server_response = await ajaxUser.UserForgotPassword(data);
    if (server_response.status === "OK") {
      localStorage.setItem("FuelFy@daisy", server_response.details);
      const currentTime = new Date().getTime();
      localStorage.setItem("loginTime", currentTime.toString());
      navigate("/");
      window.location.reload();
      toast.success(server_response.message);
    } else {
      toast.error(server_response.message);
    }
  };

  return (
    <div
      className="side-menu"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/farm-wise_login.jpeg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",

        color: "white",
        fontFamily: "cursive",
        fontSize: "20px",
      }}
    >
      <Toaster />
      <div className="page main-signin-wrapper">
        {/* Row */}
        <div className="row signpages text-center">
          <div className="col-md-12">
            <div
              className="card"
              style={{
                background: "rgba(117, 147, 141, 0.4)",
                backdropFilter: "blur(10px)",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              <div className="row row-sm">
                <div className="col-lg-6 col-xl-5 d-none d-lg-block text-center  ">
                  <div className="mt-5 pt-4 p-2 pos-absolute">
                    <img
                      src={process.env.PUBLIC_URL + "/FuelFy_logo.png"}
                      className="header-brand-img mb-4"
                      alt="logo"
                    />
                    <div className="clearfix" />
                  </div>
                </div>
                <div className="col-lg-6 col-xl-7 col-xs-12 col-sm-12  ">
                  <div className="main-container container-fluid">
                    <div className="row row-sm">
                      <div className="card-body mt-2 mb-2">
                        <form>
                          <h2 className="mt-4 text-white">
                            Forgot Account Password
                          </h2>

                          <div className="form-group text-start">
                            <label
                              style={{
                                color: "white",
                                fontFamily: "cursive",
                                fontSize: "30px",
                              }}
                            >
                              Email
                            </label>
                            <input
                              className="form-control"
                              placeholder="Enter your email"
                              type="text"
                            />
                          </div>
                          <a
                            onClick={(e) => handleSubmit(e)}
                            href="#"
                            className="btn btn-main-primary btn-block text-white"
                          >
                            Sign In
                          </a>
                        </form>
                        <div className="text-start mt-5 ms-0">
                          <div className="mb-1">
                            <a href="/login"> back to login</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Row */}
      </div>
    </div>
  );
}

export default ForgotPassword;
